import './styles';

import React from 'react';

import SummaryTab from './summary_tab';
import CitationsTab from './citations_tab';
import CitingResearchCategoriesTab from './citing_research_categories_tab';

import Lightbox from 'details/components/lightbox';
import Glossary from 'details/components/lightbox/glossary';

import WindowManager from 'details/utils/window_manager';

import Analytics from 'shared/analytics';

export default class DocumentTabs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeTab: this.props.tab || 'summary',
            glossaryVisible: false
        };
    }

    render() {
        return (
            <div className="DocumentTabs">
                <div className="DocumentTabs-tabs">
                    {this.renderTab({ tab: 'summary', text: 'Summary' })}
                    {this.renderTab({ tab: 'citations', text: 'Citations' })}
                    {this.renderTab({ tab: 'categories', text: 'Citing research categories' })}
                </div>
                <div className="DocumentTabs-content">{this.renderTabContent()}</div>
                <Lightbox visible={this.state.glossaryVisible} onClose={this.toggleGlossary}>
                    <Glossary />
                </Lightbox>
            </div>
        );
    }

    renderTab({ tab, text }) {
        return (
            <a
                className={`DocumentTabs-tab ${this.state.activeTab == tab ? 'active' : 'inactive'}`}
                onClick={event => this.handleClick(tab, event)}
            >
                {text}
            </a>
        );
    }

    renderTabContent() {
        switch (this.state.activeTab) {
            case 'summary':
                return <SummaryTab publication={this.props.publication} onToggleGlossary={this.toggleGlossary} />;
            case 'citations':
                return <CitationsTab publication={this.props.publication} />;
            case 'categories':
                return <CitingResearchCategoriesTab publication={this.props.publication} />;
        }
    }

    handleClick = (tab, event) => {
        event.preventDefault();

        let tabURL = WindowManager.canonicalURL(this.props.rootURL, this.props.publication);
        if (tab != 'summary') {
            tabURL = `${tabURL}/${tab}`;
        }

        try {
            window.history.replaceState({}, null, tabURL);
        } catch (e) {
            // Don't fail if the history API is unavailable
        }

        Analytics.recordTabChange();
        this.setState({ activeTab: tab });
    };

    toggleGlossary = () => {
        this.setState({
            glossaryVisible: !this.state.glossaryVisible
        });
    };
}
